import React from 'react';

interface IsErrorCloseProps {
    fill?: string;
}

export const IsErrorClose = ({ fill = 'currentColor' }: IsErrorCloseProps) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_188_2107)">
            <path
                d="M8.23817 7.00016L13.7435 1.49483C13.9076 1.33064 13.9998 1.10799 13.9998 0.87583C13.9998 0.643671 13.9076 0.421017 13.7435 0.256831C13.5793 0.092695 13.3567 0.000488281 13.1245 0.000488281C12.8923 0.000488281 12.6697 0.092695 12.5055 0.256831L7.00017 5.76216L1.49455 0.256831C1.33037 0.092695 1.10771 0.000488281 0.875556 0.000488281C0.643397 0.000488281 0.420743 0.092695 0.256557 0.256831C0.0924203 0.421017 0.000213623 0.643671 0.000213623 0.87583C0.000213623 1.10799 0.0924203 1.33064 0.256557 1.49483L5.76217 7.00016L0.256557 12.5055C0.175288 12.5868 0.110825 12.6833 0.0668503 12.7895C0.0228752 12.8957 0.000248485 13.0095 0.000262033 13.1244C0.000275582 13.2394 0.0229291 13.3532 0.0669293 13.4594C0.110929 13.5656 0.175414 13.6621 0.256703 13.7433C0.337991 13.8246 0.43449 13.8891 0.540691 13.933C0.646891 13.977 0.760714 13.9996 0.875659 13.9996C0.990604 13.9996 1.10442 13.977 1.21061 13.933C1.3168 13.889 1.41329 13.8245 1.49455 13.7432L7.00017 8.23786L12.5055 13.7432C12.6765 13.9142 12.9007 13.9997 13.1245 13.9997C13.3483 13.9997 13.5725 13.9142 13.7435 13.7432C13.9076 13.579 13.9998 13.3563 13.9998 13.1242C13.9998 12.892 13.9076 12.6694 13.7435 12.5052L8.23817 7.00016Z"
                fill="#EC3030"
            />
        </g>
        <defs>
            <clipPath id="clip0_188_2107">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
